import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VirtualScrollerModule } from '@iharbeck/ngx-virtual-scroller';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';

import { FormModule } from 'app/form/form.module';
import { ListComponent } from 'app/lists/list/list.component';
import { ListAttachmentPreviewerComponent } from 'app/lists/list-attachments-previewer/list-attachments-previewer.component';
import { ListCompanyDetailsPageComponent } from 'app/lists/list-company-details-page/list-company-details-page.component';
import { ListCompanyPageComponent } from 'app/lists/list-company-page/list-company-page.component';
import { ListCompanyUnsubscriptionComponent } from 'app/lists/list-company-unsubscription/list-company-unsubscription.component';
import { ListDetailToolBarComponent } from 'app/lists/list-detail-tool-bar/list-detail-tool-bar.component';
import { ListExpiryNotificationManagementComponent } from 'app/lists/list-expiry-notification-management/list-expiry-notification-management.component';
import { ListFieldAttachmentComponent } from 'app/lists/list-field-attachment/list-field-attachment.component';
import { ListFieldDateComponent } from 'app/lists/list-field-date/list-field-date.component';
import { ListFieldDateExpiryComponent } from 'app/lists/list-field-date-expiry/list-field-date-expiry.component';
import { ListFieldNumberComponent } from 'app/lists/list-field-number/list-field-number.component';
import { ListFieldTextComponent } from 'app/lists/list-field-text/list-field-text.component';
import { ListHeaderAttachmentComponent } from 'app/lists/list-header-attachment/list-header-attachment.component';
import { ListHeaderDateComponent } from 'app/lists/list-header-date/list-header-date.component';
import { ListHeaderDateExpiryComponent } from 'app/lists/list-header-date-expiry/list-header-date-expiry.component';
import { ListHeaderEditComponent } from 'app/lists/list-header-edit/list-header-edit.component';
import { ListHeaderNumberComponent } from 'app/lists/list-header-number/list-header-number.component';
import { ListHeaderTextComponent } from 'app/lists/list-header-text/list-header-text.component';
import { ListItemsService } from 'app/lists/list-items.service';
import { ListProjectDetailsPageComponent } from 'app/lists/list-project-details-page/list-project-details-page.component';
import { ListProjectPageComponent } from 'app/lists/list-project-page/list-project-page.component';
import { ListProjectUnsubscriptionComponent } from 'app/lists/list-project-unsubscription/list-project-unsubscription.component';
import { ListPropertyAddComponent } from 'app/lists/list-property-add/list-property-add.component';
import { ListPropertyKindComponent } from 'app/lists/list-property-kind/list-property-kind.component';
import { ListThumbnailComponent } from 'app/lists/list-thumbnail/list-thumbnail.component';
import { ListToolBarComponent } from 'app/lists/list-tool-bar/list-tool-bar.component';
import { ListTypeaheadComponent } from 'app/lists/list-typeahead/list-typeahead.component';
import { ListsRoutingModule } from 'app/lists/lists-routing.module';
import { SharedModule } from 'app/shared/shared.module';
import { UIComponentsModule } from 'app/ui-components/ui-components.module';

import { AddListModalComponent } from './add-list/add-list-modal.component';
import { AddListComponent } from './add-list/add-list.component';
import { BulkApplyListRowStyleModal } from './bulk-apply-list-row-style/bulk-apply-list-row-style-modal.component';
import { EmptyListStateComponent } from './list/empty-list-state/empty-list-state.component';
import { ListHeaderPropertyComponent } from './list/list-header-property/list-header-property.component';
import { ListPropertyComponent } from './list/list-property/list-property.component';
import { ListPropertyHostDirective } from './list/list-property-host.directive';
import { ListItemSelectionService } from './list-item-selection.service';
import { ListOverwriteWarningComponent } from './list-overwrite-warning/list-overwrite-warning.component';
import { AutoGrowingInputDirective } from '../shared/directive/auto-growing-input.directive';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgbModule,
    SharedModule,
    ListsRoutingModule,
    FormModule,
    UIComponentsModule,
    VirtualScrollerModule,
    UIComponentsModule,
  ],
  declarations: [
    AutoGrowingInputDirective,
    AddListComponent,
    AddListModalComponent,
    BulkApplyListRowStyleModal,
    ListAttachmentPreviewerComponent,
    ListComponent,
    ListCompanyDetailsPageComponent,
    ListCompanyPageComponent,
    ListCompanyUnsubscriptionComponent,
    ListDetailToolBarComponent,
    ListExpiryNotificationManagementComponent,
    ListFieldAttachmentComponent,
    ListFieldDateComponent,
    ListFieldDateExpiryComponent,
    ListFieldNumberComponent,
    ListFieldTextComponent,
    ListHeaderAttachmentComponent,
    ListHeaderDateComponent,
    ListHeaderDateExpiryComponent,
    ListHeaderEditComponent,
    ListHeaderNumberComponent,
    ListHeaderTextComponent,
    ListProjectPageComponent,
    ListProjectUnsubscriptionComponent,
    ListPropertyAddComponent,
    ListProjectDetailsPageComponent,
    ListPropertyKindComponent,
    ListThumbnailComponent,
    ListToolBarComponent,
    ListTypeaheadComponent,
    ListOverwriteWarningComponent,
    EmptyListStateComponent,
    ListPropertyHostDirective,
    ListPropertyComponent,
    ListHeaderPropertyComponent,
  ],
  providers: [ListItemsService, ListItemSelectionService],
})
export class ListsModule {}
